module.exports = __webpack_public_path__ + "static/img/gaozhonglishi3.6190e114.jpg";